<template>
  <v-toolbar
    data-js="get-height"
    class="toolbar--white action-bar overflow--y"
    :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    flat
  >
    <Breadcrumb :routes="breadcrumbItems" />
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import Breadcrumb from 'components/Breadcrumb'

export default {
  name: 'ActionBar',
  components: {
    Breadcrumb
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany,
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen
    })
  },
  data () {
    return {
      namespace: 'Views.CreditPoliciesPage',
      breadcrumbItems: [
        { title: this.$t('Common.settings') },
        { name: 'CreditPolicies', title: this.$t('Views.CreditPoliciesPage.title') }
      ]
    }
  }
}
</script>
